import {ApiClientService, EntityApiService} from "@dfl/react-security";
import {ISpaceSetting} from "modules/admin/interfaces";


class SpaceSettingService extends EntityApiService<ISpaceSetting> {

    getProperty = (id:any) => ApiClientService.get(this.getPath(`/property/${id}`))
    
    updateProperty = (params:any) => ApiClientService.patch(this.getPath(`/property/${params.typo}`), params)
    
    getLanguageInput = (id:any) => ApiClientService.get(this.getPath(`/language-input`))
}

export default new SpaceSettingService('/ms-auth/api/space-settings');
